import { ModifierType } from '@square/dashboard-items-data/models/item-modifier-list';
import { isNone } from '@ember/utils';
export function isListModifierType(modifierType) {
  // Check for LIST type; if the modifierType attribute is not set, consider it a LIST modifier
  return isNone(modifierType) || modifierType === ModifierType.LIST;
}
export function getModifierListsForItems(store, items) {
  const modifierListIds = new Set();
  const modifierListInfos = items.flatMap(i => i.item_data?.modifier_list_info ?? []);
  modifierListInfos.forEach(mli => {
    modifierListIds.add(mli.modifier_list_id);
  });
  const modifierListIdPromises = [...modifierListIds].map(modifierListId => store.findRecord('connect/modifier-list', modifierListId));
  return Promise.all(modifierListIdPromises);
}